import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import {
  ApiDataResponse,
  AuthorizationGuard,
  AuthorizationRole,
} from "../types";

interface IGetDataProps {
  guardName: AuthorizationGuard;
}

interface GetRolesRequest extends IGetDataProps {
  token: string;
}

export const QUERY_KEY_FOR_ROLES = "authorization-roles";
const AUTHORIZATION_URL = `${END_POINT.BASE_URL}/v1/administrator/authorization`;

const getRoles = async ({
  token,
  guardName,
}: GetRolesRequest): Promise<ApiDataResponse<AuthorizationRole[]>> => {
  const response = await axios.get<ApiDataResponse<AuthorizationRole[]>>(
    `${AUTHORIZATION_URL}/roles`,
    {
      params: { guard_name: guardName },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const useGetRoles = ({ guardName }: IGetDataProps) => {
  const { token } = useGetUserInfo();
  return useQuery<ApiDataResponse<AuthorizationRole[]>, Error>(
    [QUERY_KEY_FOR_ROLES, guardName],
    () => getRoles({ guardName, token }),
    {
      enabled: Boolean(token),
    }
  );
};